<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <adicionar-cargo-departamento-dialog
      :is-dialog-open.sync="isAssociarCargoDepartamentoDialogOpen"
      :cargo-id="cargoId"
      @refetch-data="getDepartamentosAssociados"
    />

    <v-card class="d-flex justify-space-between">
      <v-card-title>Departamentos</v-card-title>

      <v-btn
        color="primary"
        class=" ma-3"
        @click="isAssociarCargoDepartamentoDialogOpen = !isAssociarCargoDepartamentoDialogOpen"
      >
        <span>Adicionar</span>
      </v-btn>
    </v-card>

    <div style="min-height: 4px">
      <v-progress-linear
        v-if="loading"
        indeterminate
      />
    </div>

    <table-cargo-departamento
      :items="departamentos"
      :cargo-id="cargoId"
      @refetch-data="getDepartamentosAssociados"
    />
  </v-card>
</template>

<script>
import { onMounted, ref } from '@vue/composition-api'
import AdicionarCargoDepartamentoDialog from './AdicionarCargoDepartamentoDialog.vue'
import TableCargoDepartamento from './TableCargoDepartamento.vue'
import CargoService from '@/services/modules/CargoService'

export default {
  components: {
    AdicionarCargoDepartamentoDialog,
    TableCargoDepartamento,
  },

  props: {
    cargoId: {
      type: Number,
      required: true,
    },
  },

  setup(props) {
    const isAssociarCargoDepartamentoDialogOpen = ref(false)
    const departamentos = ref([])
    const loading = ref(false)

    async function getDepartamentosAssociados() {
      loading.value = true
      try {
        departamentos.value = await CargoService.getDepartamentosAssociadosAUmCargo(props.cargoId)
      } finally {
        loading.value = false
      }
    }
    onMounted(getDepartamentosAssociados)

    return {
      isAssociarCargoDepartamentoDialogOpen,
      departamentos,
      loading,
      getDepartamentosAssociados,
    }
  },
}
</script>
